import { AnalyticsRealtorsComponent } from "@/components/analytics-realtors/analytics-realtors.component";
import { BasePageComponent } from "@/components/base/BasePageComponent";
import { UserHelper } from "@/helpers/user.helper";
import { NavService } from "@/services/nav.service";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AnalyticsComponent } from "../../components/analytics/analytics.component";
import { PageTitleComponent } from "../../components/page-title/page-title.component";

@Component({
  selector: "app-kpis",
  templateUrl: "./kpis.component.html",
  styleUrls: ["./kpis.component.scss"],
  standalone: true,
  imports: [PageTitleComponent, AnalyticsComponent, AnalyticsRealtorsComponent],
})
export class KpisComponent extends BasePageComponent implements OnInit {
  isRealtor = false;

  constructor(
    protected route: ActivatedRoute,
    protected navService: NavService,
    private userHelper: UserHelper
  ) {
    super(route, navService);
  }

  ngOnInit() {
    this.isRealtor = this.userHelper.isRealEstate();
  }
}
